import * as React from 'react';
import last from 'lodash/last';
import { clsx } from 'clsx';
import { StringOperator } from 'common/widgets/property-filter-menu/models/types';
import { PropertyValuesScreenReact } from 'common/widgets/property-filter-menu/property-values-screen';
import { SelectTheme } from 'common/components/select/constants';
import { SelectReact } from 'common/components/select';
import { CommitPropertyFilterEvent } from 'common/widgets/property-filter-menu/property-values-screen/types';
import { useTranslation } from 'common/i18n/hooks';
import { FilterValueProps } from '../types';
const NO_VALUE_OPERATORS = new Set<StringOperator>([StringOperator.Set, StringOperator.NotSet]);
export function FilterStringValue(props: FilterValueProps) {
  const {
    t
  } = useTranslation();
  return (
    // set and not set do not require a filter value input
    !NO_VALUE_OPERATORS.has(props.filter.filterOperator as StringOperator) && <SelectReact className={clsx("filter-value-select", {
      'is-placeholder': !props.filter.isValid()
    })} elref='filterValueSelect' open={props.isActive} theme={props.hasNewUI ? SelectTheme.Tertiary : SelectTheme.Select} neverShowCaret selectedOption={props.filter.isValid() ? props.filter.getValuesLabel() : t("query-builder.value-placeholder")} readonly={props.readonly} disabled={props.disabled} tooltip={props.tooltip ? {
      text: props.tooltip
    } : undefined} onMenuChange={ev => props.onSelectMenuChange(ev)}>
        {props.isActive && <PropertyValuesScreenReact elref='filterValue' slot='body' displayValueOnly eventNames={props.eventNames} propertyFilter={props.filter.getAttributes()} projectId={props.projectId} workspaceId={props.workspaceId} listProperty={last(props.filter.getParents())} onCommitPropertyFilter={(ev: CommitPropertyFilterEvent) => props.onChange(ev.detail.propertyFilter.filterValue)} />}
      </SelectReact>
  );
}